module.exports = __webpack_public_path__ + "media/virtualStagingSlider/virtualStagingSlider1Pre-1c6df12f.jpeg";